import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom";

import { configurationsConstants } from "../../../../constants";
import { customerDashboardActions } from "../../../../redux/actions";

const ReferAFriend = ({ userId, referAFriend }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const { referEmail } = Object.fromEntries(formData);

    referAFriend({
      userId: userId,
      email: referEmail,
    });
  };

  return (
    <>
      <div className="container refer-a-friend-tab py-3">
        <div className="row">
          <div className="col px-0">
            <h5 className="p-0 m-0 mb-1">get 10$ off</h5>
            <p className="p-0 m-0 mb-3">
              refer a friend and when they book a shutterb you will each get $10
              off your next event.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col px-0">
            <form onSubmit={handleSubmit} autoComplete="off">
              <div className="mb-1">
                <label htmlFor="referEmail">enter email id:</label>
              </div>
              <input
                type="email"
                name="referEmail"
                placeholder="friend@gmail.com"
                pattern="^[a-z,A-Z,0-9,!@#$%^&*_=+-].{3,}$"
                minLength={3}
                maxLength={configurationsConstants.EMAIL_INPUT_LENGTH}
                required
              />
              <button className="btn-simple mb-2" type="submit">
                send invite
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  userId: state.authentication.userId,
  userName: state.authentication.userName,
});

const mapDispatchToProps = (dispatch) => ({
  referAFriend: (dataObj) => {
    dispatch(customerDashboardActions.referAFriend(dataObj));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ReferAFriend));
